import { Paper } from "@mui/material";
import React from "react";
import Draggable from 'react-draggable';

const  PaperComponent = (props) => {

  const nodeRef = React.useRef(null);
  return (
    <div onMouseDown={e => e.stopPropagation()} style={{ display: 'contents' }}>
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
        nodeRef={nodeRef}>
        <Paper ref={nodeRef} {...props} />
      </Draggable>
    </div>
  );
}

export default PaperComponent
